import { render, staticRenderFns } from "./StoreCouponsViewer.vue?vue&type=template&id=123822e0&"
import script from "./StoreCouponsViewer.vue?vue&type=script&lang=js&"
export * from "./StoreCouponsViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports